module.exports = __webpack_public_path__ + "img/background.385aa4b7.svg";